import {Injectable} from '@angular/core';
import {AppMenuItem} from '../interfaces/menu-config-interface';
import {APP_MENU} from '../../core/menu/app-menu';
import {Observable, of} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuConfigService {
  loadMenu(): Observable<AppMenuItem[]> {
    return of(APP_MENU);
  }
}
